import API from './config'

export const UserAPI = {
    async login(cpf, password) {

        try {

            const response = await API.post('/users/login', {
                cpf: cpf,
                password: password
            })

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error);

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async me() {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            console.log("CHAMANDO ME")
            const response = await API.get('/users/me', config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error)

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }

    },

    async create(user) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/users', user, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }

    },

    async updateUser(userId, user) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.put('/users/update', {
                id: userId,
                user: user
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }

    },

    async deleteUser(userId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.delete('/users/delete/' + userId, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }

    },

    async listAllAdvisors() {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/users/listAllAdvisors', config)

            console.log("Response: ", response)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async listAllAdvisorsAndAdmins() {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/users/listAllAdvisorsAndAdmins', config)

            console.log("Response: ", response)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async listAllAdvisorsAndAdminsByConsulting(consultingId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/users/listAllAdvisorsAndAdminsByConsulting/' + consultingId, config)

            console.log("Response: ", response)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAdvisorByNameOrCPF(searchInputValue) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/users/getAdvisorByNameOrCPF/' + searchInputValue, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAdvisorOrAdminByNameOrCPF(searchInputValue) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/users/getAdvisorOrAdminByNameOrCPF/' + searchInputValue, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAdvisorOrAdminByNameOrCPFByConsulting(searchInputValue, consultingId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/users/getAdvisorOrAdminByNameOrCPFByConsulting?search=' + searchInputValue + "&consulting_id=" + consultingId, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async updateStatus(userId, status) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.put('/users/updateStatus', {
                id: userId,
                status: status,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getManagersByClient(clientId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        console.log("CLIENT_ID: ", clientId)

        try {

            const response = await API.post('/users/getManagersByClient', {
                client_id: clientId
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getActiveAdvisors() {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/users/getActiveAdvisors', config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getActiveAdvisorsAndAdmins() {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/users/getActiveAdvisorsAndAdmins', config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getActiveAdvisorsAndAdminsByConsulting(consultingId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/users/getActiveAdvisorsAndAdminsByConsulting/' + consultingId, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async addClientToAdvisor(clientId, userId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        console.log("CLIENT_ID: ", clientId)

        try {

            const response = await API.post('/users/addClientToAdvisor', {
                client_id: clientId,
                user_id: userId,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async removeClientToAdvisor(advisorClientId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.delete('/users/removeClientToAdvisor/' + advisorClientId, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAdvisorClients(advisorId, orderBy) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/users/getAdvisorClients/', {
                advisor_id: advisorId,
                orderBy: orderBy
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getUserEmailByCpf(cpf) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            console.log("ENVIANDO CPF: ", cpf);
            const response = await API.get('/users/getUserEmailByCpf/' + cpf, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getUserByCpf(cpf) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/users/getUserByCpf/' + cpf, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }

    },

    async linkExistingUserToClient(userId, clientId, roleId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/users/linkExistingUserToClient', {
                user_id: userId,
                client_id: clientId,
                role_id: roleId,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }

    },

    async updatePassByHash(hash, newPass) {

        try {

            const response = await API.post('/users/updatePassByHash', { hash: hash, password: newPass })

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async checkHashResetPass(hash) {

        try {

            const response = await API.post('/users/checkHashResetPass', { hash })

            return {
                success: true,
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async shouldShowImprovementsPopup() {

        const config = { headers: { 'x-access-token': localStorage.getItem('token'), } }

        try {

            const response = await API.get(`/users/shouldShowImprovementsPopup`, config)

            return {
                success: true,
                data: response.data,
            };

        } catch (error) {

            console.log("Error: ", error);
            return {
                success: false,
            };
        }

    },

    async shouldShowSuitabilityNotice(clientId) {

        const config = {
            headers: { 'x-access-token': localStorage.getItem('token'), },
            params: { client_id: clientId },
        }

        try {

            const response = await API.get(`/users/shouldShowSuitabilityNotice`, config)

            return {
                success: true,
                data: response.data,
            };

        } catch (error) {

            console.log("Error: ", error);
            return {
                success: false,
            };
        }

    },
}